import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
/**
 * Generated class for the ToggleInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "toggle-input",
  templateUrl: "toggle-input.html",
})
export class ToggleInputComponent implements OnInit {
  // Configuration properties
  @Input() group: FormGroup;
  @Input() config;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  value: boolean;
  disabled: boolean = false;
  readonly: boolean = false;

  constructor(public formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;
    this.value = this.config.default || false;

    let selfControl = this.group.controls[this.id];
    if (selfControl.value !== undefined) {
      this.value = selfControl.value;
    }

    if (this.readonly || selfControl.disabled) {
      this.disabled = true;
    }

    selfControl.valueChanges.subscribe((data) => {
      // console.log( "Toggle data update: ", this.id, data, this.value );

      if (data !== this.value) {
        this.value = data;
      }

      if (this.readonly || selfControl.disabled) {
        // console.log( "Disabling toggle." );
        this.disabled = true;
      } else {
        // console.log( "Enabling toggle." );
        this.disabled = false;
      }
    });
  }

  valueChanged(val: boolean) {
    // console.log( "Toggle val updating: ", val );
    this.group.controls[this.id].setValue(val);
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/toggle-input/toggle-input.ts